import { Box, Button, FormControl, Card, FormControlLabel, Grid, Modal, Radio, TextField, Typography, InputAdornment } from '@mui/material'
import React, { useEffect } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import CustomButtoncolor from '../custom-button/customColorButton';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import { NoShowstatus } from '../../store/crm/crm';
import { useFormik } from 'formik';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { RadioGroup } from '@mui/material';
import Waveloading from '../../pages/loading/Waveloading';
import {MySwal} from "../../services/utills";


import successIcon from "../../assets/icon/checkmark-circle.png";
import visa from "../../assets/icon/visa.png";

import { defaultUserCard, deleteUserCard, getAllExistingUserCards } from '../../store/crm/appointment/book-appointment';
import { getAppointmentcalender, getAppointmentDetails } from '../../store/crm/appointment';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 560,
    maxHeight: '88vh',
    overflowY: 'auto',
    bgcolor: '#FFFFFF',
    p: '26px 24px 22px',
    borderRadius:'14px',
    boxShadow: '0px 24px 44px rgba(15, 23, 42, 0.2)',
    '@media (max-width: 480px)': {
      width: "95%",
      p: '20px 14px',
    },
    gap:"5px"
  };
  const wrapper={
    alignItems:"center",
  }
  const heading={
    fontSize:"22px",
    fontFamily:'helvetica-lt-std-roman',
    fontWeight:'700',
    textAlign:"left",
    width:'auto'

  }
 
  export const inputStyle = {
    background: "#F8FAFC",
    borderRadius: '10px',
    ".MuiOutlinedInput-notchedOutline": {
        border: "1px solid #E2E8F0"
    },
    ".MuiInputBase-input": {
        borderColor: " #F8FAFC",
        height: "22px",
        minHeight: 'unset',
        fontSize: '15px',
        "&:focus": {
            borderColor: "#F8FAFC",
            outline: "none",
            "input": {
                height: '22px'
            }
        },
        "&:hover": {
            borderColor: "#F8FAFC",
            outline: "none",
        }
    }
}
export const btnwrappe ={
  marginTop:"5px",
  display:"flex",
  justifyContent:"flex-end",
  gap:"10px",
  borderTop: '1px solid #EEF2F7',
  paddingTop: '18px'
  
}
 export const textareaStyle = {

  height: '200px',
  border:"none",
    background: "#F5DFEA",
    borderRadius: '4px',
    outline:"none",
      "&:focus": {
        borderColor: "#F5DFEA",
        outline: "none",
      },
      "&:hover": {
        borderColor: "#F5DFEA",
        outline: "none",
    }
    
};


const NOShowmodal= ({Data}) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
     const authStore = useSelector(state => state?.authStore)
      const {user} = authStore
    // //console.log("id get",customerId, bookingId )
 
    const handleClose = () => setOpen(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('Wallet');
    const handlePaymentMethodChange = (event) => {
      setSelectedPaymentMethod(event.target.value);
    };
    const [selectedCard, setSelectedCard] = useState(null);
     const { selectedUserCard } = useSelector(state => state?.bookAppointmentStore) 
const validate = (values) => {
  const errors = {};
  const maxAmount = Number(Data?.customer?.wallet_point || 0);
  const amount = values.amount;

  if (!amount) {
    errors.amount = "Amount is required";
  }
  // Allow only numbers and decimal
  else if (!/^\d*\.?\d+$/.test(amount)) {
    errors.amount = "Only numbers are allowed";
  }
  else if (Number(amount) <= 0) {
    errors.amount = "Amount must be greater than 0";
  }
  else if (Number(amount) > maxAmount) {
    errors.amount = `Amount cannot exceed $${maxAmount}`;
  }

  return errors;
};


    const formik = useFormik({

        initialValues: {
          amount: "",
          type: "",
          paymentDetails: ""
        },
        validate,
     onSubmit: async (values) => {
  try {
    setLoading(true);

    const isWallet = selectedPaymentMethod === "Wallet";
    const walletBalance = Number(Data?.customer?.wallet_point || 0);
    const amount = Number(formik.values.amount || 0);
    const cards = selectedUserCard?.data?.cards || [];

    let paymentMethodToken = null;

    // 🔴 WALLET VALIDATION
    if (isWallet) {
      if (walletBalance <= 0) {
        toast.error("Your wallet balance is zero.");
        setLoading(false);
        return;
      }

      if (walletBalance < amount) {
        toast.error("Insufficient wallet balance.");
        setLoading(false);
        return;
      }
    }

    // 🔴 CARD VALIDATION
    if (!isWallet) {
      if (cards.length === 0) {
        toast.error("Please add a card to continue.");
        setLoading(false);
        return;
      }

      const activeCard = cards.find(card => card.status === "Active");

      if (!activeCard) {
        toast.error("Please select an active card.");
        setLoading(false);
        return;
      }

      paymentMethodToken = activeCard.id;
    }

    // ✅ API payload
    const finalPayload = {
      booking_id: Data?.id,
      invoices: [
        isWallet
          ? {
              name: "Wallet",
              amount,
              payment_method_id: "2",
            }
          : {
              token: paymentMethodToken,
              name: "Card",
              amount,
              payment_method_id: "4",
            },
      ],
    };

    const result = await dispatch(NoShowstatus(finalPayload));

    if (NoShowstatus.fulfilled.match(result)) {
      const payload = result.payload;

      if (payload?.success === "true") {
        toast.success("Appointment updated successfully");
        handleClose();
        dispatch(getAppointmentDetails(Data?.id));
       dispatch(getAppointmentcalender(Data?.id))
      } else {
        // toast.error(payload?.errors?.[0] || payload?.message);
      }
    } else {
      // toast.error(
      //   result?.payload?.errors?.[0] ||
      //   result?.error?.message ||
      //   "Request failed."
      // );
    }
  } catch (error) {
    // toast.error("Unexpected error occurred.");
  } finally {
    setLoading(false);
  }
},


    });
 const handleOpen = () => {
  resetModalState();
  setOpen(true);
};
const resetModalState = () => {
  formik.resetForm();
  setSelectedPaymentMethod("Wallet");
  setSelectedCard(null);
};
    const handleCloseModal = () => {
        handleClose();
        resetModalState()
    };

       useEffect(() => {
            const fetchExistingUserCards = async () => {
              const customerId = Data?.customer?.id 
              //console.log("id",customerId,selectedCustomerId,selectedCustomer?.id)
              if (customerId) {
                const { payload } = await dispatch(getAllExistingUserCards(customerId))
              }
            };
        
            fetchExistingUserCards();
          }, [ selectedPaymentMethod, dispatch]);
        const defaultusercard = async (cardId) => {
            const result = await MySwal.fire({
              title: 'Are you sure?',
              text: "Do you want to make this card default?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, make it default'
            });
        
            if (result.isConfirmed) {
              setLoading(true);
        
              //console.log("card data", selectedUserCard);
              const payload = {
                card_id: cardId,
                provider_id: user?.id,
                user_id: selectedUserCard?.data?.user?.id,
              };
              //console.log("data", payload);
        
              try {
                await dispatch(defaultUserCard(payload));
                const customerId = Data?.customer?.id
                // const response = await dispatch(getmemshiplistdeatil(customerId))
                //console.log("id",customerId,selectedCustomerId,selectedCustomer?.id)
                if (customerId ) {
                  const { payload } = await dispatch(getAllExistingUserCards(customerId))
                }
        
        
                setSelectedCard(cardId);
              } catch (error) {
                console.error("Error in defaultUserCard:", error);
        
              } finally {
                setLoading(false);
        
              }
            } else {
        
            }
          };
        
          const deleteusercard = async (cardId) => {
            const result = await MySwal.fire({
              title: 'Are you sure?',
              text: "Do you want to delete this card?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, delete it'
            });
        
            if (result.isConfirmed) {
              setLoading(true);
        
              const customerId = Data?.customer?.id
              const providerId = user?.id;
        
              if (!customerId || !providerId) {
                toast.error("Error: Missing customer or provider information.");
                setLoading(false);
                return;
              }
        
              //console.log("card data", selectedUserCard?.data?.application_token);
        
              const payload = {
                card_id: cardId,
                customer_id: Data?.customer?.id,
                provider_id: providerId,
              };
        
              //console.log("data", payload);
        
              try {
                await dispatch(deleteUserCard(payload));
              } catch (error) {
                console.error("Error in deleteUserCard:", error);
              } finally {
                try {
                  await dispatch(getAllExistingUserCards(customerId));
                } catch (error) {
                  console.error("Error in getAllExistingUserCards:", error);
                }
                setLoading(false);
              }
            }
          };
        
    return (
        <>
            <Button
              onClick={handleOpen}
              variant="contained"
              sx={{
                mt: 0.8,
                width: { xs: "100%", sm: "auto" },
                minWidth: { sm: "200px" },
                minHeight: "44px",
                px: 2.8,
                borderRadius: "10px",
                textTransform: "none",
                fontSize: "18px",
                fontWeight: 700,
                letterSpacing: "0.2px",
                color: "#FFFFFF",
                background: "linear-gradient(180deg, #38BDF8 0%, #0284C7 100%)",
                boxShadow: "0px 10px 20px rgba(2, 132, 199, 0.3)",
                "&:hover": {
                  background: "linear-gradient(180deg, #22C8FF 0%, #0369A1 100%)",
                  boxShadow: "0px 12px 24px rgba(2, 132, 199, 0.36)",
                },
              }}
            >
              No Show Charge
            </Button>
            {loading?<Waveloading fullSize/>:
             <Modal
      style={{}}
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: "blur(3px)",
            backgroundColor: "rgba(15, 23, 42, 0.45)",
          },
        },
      }}
    >
      <Box sx={style}>
        <Grid container spacing={1} sx={wrapper}>
          <Grid item lg={12} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.3 }}>
              {/* <ArrowBackIosNewIcon sx={{ fontSize: 18, cursor: "pointer", color: "#334155" }} onClick={handleCloseModal} /> */}
              <Box>
                <Typography id="modal-modal-title" sx={heading}>
                  No Show Charge
                </Typography>
                <Typography sx={{ fontSize: "12px", color: "#64748B", mt: 0.2 }}>
                  Select payment method and charge amount
                </Typography>
              </Box>
            </Box>
            <CloseIcon sx={{ color: "#f10b0b", cursor: "pointer" }} onClick={handleCloseModal} />
          </Grid>
          <Box style={{ marginTop: '18px', width: "100%", padding: "0px 3px 0px 10px" }}>
            <Grid item lg={12} md={12} sm={12}>
                  <FormControl fullWidth> 
                <Typography sx={{ mb: 0.8, color: '#334155', fontSize: '14px', fontWeight: 600 }}>Amount</Typography>
                <TextField
                  fullWidth
                  name="amount"                
                  sx={inputStyle}
                  placeholder="0.00"
                  value={formik.values.amount} 
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}            
                  InputProps={{
                    sx: { textAlign: "center" },
                    startAdornment: (
                      <InputAdornment position="start"  sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
                        <Typography sx={{ color: '#64748B', fontWeight: 600 }}>$</Typography>
                      </InputAdornment>
                    ),
                  }}
                />
                {formik.touched.amount && formik.errors.amount && (
                  <Typography color="error" sx={{ fontSize: "12px", mt: 0.8 }}>{formik.errors.amount}</Typography>
                )} 
              </FormControl>         
            </Grid>    
            <Grid item lg={12} md={12} sm={12}>
              <Typography sx={{ mt: 2, mb: 0.8, color: '#334155', fontSize: '14px', fontWeight: 600 }}>Payment Method</Typography>
              <FormControl fullWidth> 
                <RadioGroup                     
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={selectedPaymentMethod}
                  onChange={handlePaymentMethodChange}
                  name="radio-buttons-group"
                >
                  <Box sx={{ border: selectedPaymentMethod === "Wallet" ? "1px solid #0EA5E9" : "1px solid #E2E8F0", borderRadius: "10px", px: 1.2, py: 0.5, bgcolor: selectedPaymentMethod === "Wallet" ? "#F0F9FF" : "#FFFFFF" }}>
                    <FormControlLabel
                      value="Wallet"
                      control={<Radio />}
                       label={`Wallet (Available: $${Data?.customer?.wallet_point || 0})`}
                    />
                  </Box>
                  <Box sx={{ mt: 1.2, border: selectedPaymentMethod === "Card" ? "1px solid #0EA5E9" : "1px solid #E2E8F0", borderRadius: "10px", px: 1.2, py: 0.5, bgcolor: selectedPaymentMethod === "Card" ? "#F0F9FF" : "#FFFFFF" }}>
                    <FormControlLabel value="Card" control={<Radio />} label="Credit/Debit Card (External device)" />
                  </Box>
                  {selectedPaymentMethod === "Card" && (
  <Grid item lg={12} md={12} sm={12}>
    
  

   

      <Box sx={{ mt: 2 }}>
        {selectedUserCard?.data?.cards?.length > 0 ? ( 
          selectedUserCard.data.cards.map((item, index) => (  
            <Box key={index} sx={{ position: "relative", mt: 2 }}>  
              
              <Box sx={{ position: "absolute", top: -11, right: -3 }}>
                <CloseIcon
                  sx={{ color: "#EB5757", cursor: "pointer" }}
                  onClick={() => deleteusercard(item.id)}
                />
              </Box>

              <Card 
                sx={{
                  border: `1px solid ${
                    selectedCard === (item.token || item.id) ||
                    item.status === "Active" 
                      ? "#0EA5E9"
                      : "#CBD5E1" 
                  }`,
                  cursor: "pointer",
                  borderRadius: "10px",
                  boxShadow: selectedCard === (item.token || item.id) || item.status === "Active" ? "0px 8px 20px rgba(2, 132, 199, 0.16)" : "none",
                }}
                onClick={() => defaultusercard(item.id)}
              >
                <Box sx={{ display: "flex", alignItems: "center", px: 2, py: 1.2 }}>
                  <img src={visa} width="45" alt="" /> 
                  <Typography sx={{ ml: 2 }}>
                    {item.cardType || item.card_brand} - {item.last4 || item.last_4}
                  </Typography>

                  {(selectedCard === (item.token || item.id) || 
                    item.status === "Active") && (
                    <Box sx={{ ml: "auto" }}>
                      <img src={successIcon} alt="" />
                    </Box>
                  )}
                </Box>
              </Card>
            </Box>
          ))
        ) : (
          <Typography sx={{ mt: 2 }} color="text.secondary">
            No existing card available
          </Typography>
        )}
      </Box>
  </Grid>
)}
                </RadioGroup>
              </FormControl>
            </Grid>
          </Box>
      
    
        </Grid>

        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          sx={{ ...btnwrappe, mt: "24px" }}                 
        >
          <CustomButtoncolor
            mainColor={"#4F4F4F"}
            size="md"
            val='Close'
            style={{
              padding: '10px 16px',
              fontSize: "16px",
              minWidth: 'max-content',
              borderRadius: "6px!important",
              width: "auto",
              "@media (minWidth: 420px)": {
                width: 'auto'
              },
            }}
            handleClick={handleCloseModal}
          />
        <Button  variant="contained"  size="large"
   style={{height:"46px",minWidth:"120px",
   borderRadius:'10px',
   textTransform: 'none',
   fontWeight: 700}}
   sx={{
     background: 'linear-gradient(135deg, #27AE60 0%, #1E8449 100%)',
     color: '#fff',
     border: '1px solid #27AE60',
     boxShadow: 'none',
     '&:hover': {
       background: '#219653',
       color: '#fff',
       border: '1px solid #27AE60',
       boxShadow: 'none',
     },
   }}
   onClick={formik.handleSubmit}>
         Charge
       </Button>
        </Grid>
      </Box>
    </Modal>   
            }
           
        </>
    )
}

export default NOShowmodal;

